import { TranslationContext, type ITranslationContext } from "../contexts";
import type { PropsWithChildren } from "react";

export interface TranslationProviderProps
  extends ITranslationContext,
    PropsWithChildren {}

export const TranslationProvider = ({
  children,
  ...rest
}: TranslationProviderProps) => {
  return (
    <TranslationContext.Provider value={rest}>
      {children}
    </TranslationContext.Provider>
  );
};
